// extracted by mini-css-extract-plugin
module.exports = {"arrow-btn-box":"ar","arrowBtnBox":"ar","arrow-btn-wrap-box":"as","arrowBtnWrapBox":"as","arrow-btn-text":"at","arrowBtnText":"at","arrow-btn-arrow":"au","arrowBtnArrow":"au"};